import lottie from 'lottie-web';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import lottieCharactor from '@image/darwin/lottie-charactor.json';
import lottieFirst from '@image/darwin/lottie-summary-item__figure--first.json';
import lottieSecond from '@image/darwin/lottie-summary-item__figure--second.json';
import lottieThird from '@image/darwin/lottie-summary-item__figure--third.json';

// NewsSlider
const newsSwiper = new Swiper('.news-swiper', {
  modules: [Autoplay],
  direction: 'vertical',
  effect: 'slide',
  loop: true,
  autoplay: {
    delay: 4000,
  },
  slidesPerView: 'auto',
  autoHeight: true,
  spaceBetween: 32,
});

// VoiceSlider
const voiceSwiper = new Swiper('.voice-swiper', {
  modules: [Pagination],
  slidesPerView: 'auto',
  autoHeight: true,
  spaceBetween: 32,
  pagination: {
    el: '.voice-slider-pagination',
    clickable: true,
  },
});

// scroll position
var urlHash = location.hash;
if (urlHash) {
  $('body,html').stop().scrollTop(0);
  setTimeout(function () {
    scrollToAnker(urlHash);
  }, 100);
}
function scrollToAnker(hash) {
  var target = $(hash);
  var position = target.offset().top - 70;
  $('body,html').stop().animate({ scrollTop: position }, 100);
}
$('a[href*="#"]').on('click', function () {
  var href = $(this).attr('href').substr($(this).attr('href').indexOf('#'));
  var target = $(href == '#' || href == '' ? 'html' : href);
  if (target != undefined) {
    var position = target.offset().top - 70;
    $('html, body').animate({ scrollTop: position }, 100, 'swing');
  }
  return false;
});

// 360px未満レスポンシブ用
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 360
        ? 'width=device-width,initial-scale=1'
        : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();

// ご利用の流れ下部トグルコンテンツ
$(document).ready(function () {
  $('#readmoreButton').click(function () {
    // コンテンツの開閉
    $('.readmore__content').slideToggle('slow', function () {
      // アニメーション完了後のコールバック処理
      if ($('.readmore__content').is(':visible')) {
        $('#readmoreButton .button__text').text('閉じる');
        $('#readmoreButton').addClass('is-active');
      } else {
        $('#readmoreButton .button__text').text('もっと詳しく見る');
        $('#readmoreButton').removeClass('is-active');
      }
    });
  });
});

// ボールアイコンアニメーション
document.addEventListener('DOMContentLoaded', function () {
  const ballIcons = document.querySelectorAll('.ball-icon');
  const screenWidth = window.innerWidth;
  const iconWidth = 300;
  const iconHeight = 300;
  const viewportHeight = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );

  // ランダムな数値を生成する関数
  function getRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
  }

  // アイコンをアニメーションさせる関数
  function animateBall(ball) {
    let posX = getRandomNumber(0, screenWidth - iconWidth);
    // 画面の下から始まるようにviewportHeightよりも大きく設定
    let posY = viewportHeight + iconHeight;
    let speedX = getRandomNumber(-0.5, 0.5); // 左右の動きを緩やかにする
    let speedY = getRandomNumber(1, 2);

    // アニメーション処理
    const animate = () => {
      posX += speedX;
      posY -= speedY;
      // 左右の動きを減らすために振幅を半分にする
      posX += Math.sin(posY / 100) * 0.25; // ゆっくりとした揺れの振幅を半分に
      ball.style.transform = `translate(${posX}px, ${posY}px)`;

      // アイコンが画面外に出た場合、位置をリセット
      if (posY < -iconHeight) {
        resetPosition();
      }

      requestAnimationFrame(animate);
    };

    // アイコンの位置をリセットする関数
    const resetPosition = () => {
      posX = getRandomNumber(0, screenWidth - iconWidth);
      posY = viewportHeight + iconHeight; // リセット時も画面の外から開始
      speedX = getRandomNumber(-0.5, 0.5); // X速度をリセット
      speedY = getRandomNumber(1, 2); // Y速度をリセット
    };

    animate();
  }

  // 各アイコンにアニメーションを適用
  ballIcons.forEach((ballIcon) => {
    // アニメーションをランダムに遅延させる
    const delay = getRandomNumber(0, 10000); // 0から10秒のランダムな遅延
    setTimeout(() => {
      animateBall(ballIcon);
    }, delay);
  });
});

// ハンバーガーメニューの動き
document.addEventListener('DOMContentLoaded', function () {
  const naviButton = document.querySelector('.navi-button');
  const smartphoneNaviWrap = document.querySelector('.smartphone-navi-wrap');

  naviButton.addEventListener('click', function () {
    smartphoneNaviWrap.classList.toggle('is-active');
    naviButton.classList.toggle('is-active');
  });

  const naviLinks = document.querySelectorAll('.navi__item a');
  naviLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      smartphoneNaviWrap.classList.remove('is-active');
      naviButton.classList.remove('is-active');
    });
  });
});

const lottieAnimeFVCharactor = lottie.loadAnimation({
  container: document.getElementById('lottie'),
  renderer: 'svg',
  loop: true,
  animationData: lottieCharactor,
});

const lottieAnimeBallIconFirst = lottie.loadAnimation({
  container: document.getElementById('summary-item__figure--first'),
  renderer: 'svg',
  loop: true,
  animationData: lottieFirst,
});

const lottieAnimeBallIconSecond = lottie.loadAnimation({
  container: document.getElementById('summary-item__figure--second'),
  renderer: 'svg',
  loop: true,
  animationData: lottieSecond,
});

const lottieAnimeBallIconThird = lottie.loadAnimation({
  container: document.getElementById('summary-item__figure--third'),
  renderer: 'svg',
  loop: true,
  animationData: lottieThird,
});

// ProjectDetailPageのタブ
document.querySelectorAll('.projectDetail__tab').forEach(function (tab) {
  tab.addEventListener('click', function () {
    // Remove active class from all tabs
    document.querySelectorAll('.projectDetail__tab').forEach(function (tab) {
      tab.classList.remove('projectDetail__tab--active');
    });

    // Hide all tab content
    document
      .querySelectorAll('.projectDetail__tabContent')
      .forEach(function (content) {
        content.style.display = 'none';
      });

    // Add active class to clicked tab and show corresponding tab content
    this.classList.add('projectDetail__tab--active');
    document.getElementById(this.getAttribute('data-tab')).style.display =
      'block';
  });
});
